import { css } from '@emotion/react';
import styled, { Interpolation } from '@emotion/styled';
import { pxToRem, Text, Theme } from '@lbcamden/lib-react';

import { UserName } from '~/client/components/shared/DirectoryUserInfo/DirectoryUserInfo.styled';

export const noteAuthorStyles: Interpolation<Theme> = css`
  font-size: ${pxToRem(14)};
`;

export const HistoryItemRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
  padding: ${({ theme }) => theme.spacing([3, 2])};
  background-color: ${({ theme }) => theme.colors.backgroundAlt};
  border-radius: 6px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-flow: row-reverse;
    gap: ${({ theme }) => theme.spacing(8)};
  }
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};

  a {
    display: inline-flex;
    gap: ${({ theme }) => theme.spacing(2)};
    align-items: center;

    svg {
      flex-shrink: 0;
    }
  }
`;

export const NoteContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  white-space: pre-wrap;
`;

export const NoteAuthor = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};

  ${Text}, ${UserName} {
    font-size: ${pxToRem(14)};
  }
`;

export const InlineAttributes = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const Divider = styled.div`
  align-self: stretch;
  border-left: ${({ theme }) => theme.borderLight};
`;
